import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/**
 * Search
 * =========================
 */

function searchRequest(query) {
  return {
    type: ACTION_TYPES.GET_SEARCH_RESULTS,
    payload: {
      query,
    },
  };
}

function searchSuccess(results) {
  return {
    type: ACTION_TYPES.GET_SEARCH_RESULTS_SUCCESS,
    payload: results,
  };
}

function searchFailure(error) {
  return {
    type: ACTION_TYPES.GET_SEARCH_RESULTS_FAILURE,
    error,
  };
}

export function search(query) {
  return (dispatch, getState) => {
    const { authToken } = getState();
    const payload = {
      authToken,
      query,
    };

    dispatch(searchRequest(query));
    return new Promise((resolve, reject) => {
      api
        .search(payload)
        .then((results) => {
          dispatch(searchSuccess(results));
          resolve(results);
        })
        .catch((error) => {
          dispatch(searchFailure(error));
          reject(error);
        });
    });
  };
}

export function clearSearch() {
  return {
    type: ACTION_TYPES.CLEAR_SEARCH_RESULTS,
  };
}
